<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '类型'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'symptom'
        label= '特征'>
      </el-table-column>
      <el-table-column
        prop= 'cause'
        label= '原因'>
      </el-table-column>
      <el-table-column
        prop= 'route'
        label= '传播途径'>
      </el-table-column>
      <el-table-column
        prop= 'controlZoologyMethod'
        label= '生态防治方法'>
      </el-table-column>
      <el-table-column
        prop= 'hazard'
        label= '危害'>
      </el-table-column>
      <el-table-column
        prop= 'regulartyOfEpidemic'
        label= '流行规律'>
      </el-table-column>
      <el-table-column
        prop= 'occurrencePeriodStart'
        label= '发生开始时期'>
      </el-table-column>
      <el-table-column
        prop= 'occurrencePeriodEnd'
        label= '发生结束时期'>
      </el-table-column>
      <el-table-column
        prop= 'controlPeriodStart'
        label= '防治开始时期'>
      </el-table-column>
      <el-table-column
        prop= 'controlPeriodEnd'
        label= '防治结束时期'>
      </el-table-column>
      <el-table-column
        prop= 'therapeuticPeriodStart'
        label= '治疗开始时期'>
      </el-table-column>
      <el-table-column
        prop= 'therapeuticPeriodEnd'
        label= '治疗结束时期'>
      </el-table-column>
      <el-table-column
        prop= 'part'
        label= '易发生部位'>
      </el-table-column>
      <el-table-column
        prop= 'videoMd5'
        label= '介绍视频'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
          <el-input type="number" v-model.number="form.type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="特征" :label-width="formLabelWidth" prop="symptom">
          <el-input v-model="form.symptom" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原因" :label-width="formLabelWidth" prop="cause">
          <el-input v-model="form.cause" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="传播途径" :label-width="formLabelWidth" prop="route">
          <el-input v-model="form.route" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="生态防治方法" :label-width="formLabelWidth" prop="controlZoologyMethod">
          <el-input v-model="form.controlZoologyMethod" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="危害" :label-width="formLabelWidth" prop="hazard">
          <el-input v-model="form.hazard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="流行规律" :label-width="formLabelWidth" prop="regulartyOfEpidemic">
          <el-input v-model="form.regulartyOfEpidemic" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="发生开始时期" :label-width="formLabelWidth" prop="occurrencePeriodStart">
          <el-input v-model="form.occurrencePeriodStart" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="发生结束时期" :label-width="formLabelWidth" prop="occurrencePeriodEnd">
          <el-input v-model="form.occurrencePeriodEnd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="防治开始时期" :label-width="formLabelWidth" prop="controlPeriodStart">
          <el-input v-model="form.controlPeriodStart" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="防治结束时期" :label-width="formLabelWidth" prop="controlPeriodEnd">
          <el-input v-model="form.controlPeriodEnd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="治疗开始时期" :label-width="formLabelWidth" prop="therapeuticPeriodStart">
          <el-input v-model="form.therapeuticPeriodStart" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="治疗结束时期" :label-width="formLabelWidth" prop="therapeuticPeriodEnd">
          <el-input v-model="form.therapeuticPeriodEnd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="易发生部位" :label-width="formLabelWidth" prop="part">
          <el-input v-model="form.part" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="介绍视频" :label-width="formLabelWidth" prop="videoMd5">
          <el-input v-model="form.videoMd5" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        type: null,
        name: null,
        symptom: null,
        cause: null,
        route: null,
        controlZoologyMethod: null,
        hazard: null,
        regulartyOfEpidemic: null,
        occurrencePeriodStart: null,
        occurrencePeriodEnd: null,
        controlPeriodStart: null,
        controlPeriodEnd: null,
        therapeuticPeriodStart: null,
        therapeuticPeriodEnd: null,
        part: null,
        videoMd5: null
      },
      rules: {
        type: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        occurrencePeriodStart: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        occurrencePeriodEnd: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        controlPeriodStart: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        controlPeriodEnd: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        therapeuticPeriodStart: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        therapeuticPeriodEnd: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/diseaseInsectPest/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/diseaseInsectPest/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/diseaseInsectPest/add'
          if (that.form.id) {
            url = '/diseaseInsectPest/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/diseaseInsectPest/Index.vue